import { useEffect } from "react";
import { Monitor, Smartphone, Trash2, Shield, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function SessionsContent({
  sessions, isLoadingSessions, fetchSessions,
  revokeSession, revokeAllSessions
}) {
  useEffect(() => {
    fetchSessions();
  }, [fetchSessions]);

  const getDeviceIcon = (ua) => {
    if (!ua) return Monitor;
    const lower = ua.toLowerCase();
    if (lower.includes("mobile") || lower.includes("android") || lower.includes("iphone")) {
      return Smartphone;
    }
    return Monitor;
  };

  const getBrowserName = (ua) => {
    if (!ua) return "Inconnu";
    if (ua.includes("Firefox")) return "Firefox";
    if (ua.includes("Edg")) return "Edge";
    if (ua.includes("Chrome")) return "Chrome";
    if (ua.includes("Safari")) return "Safari";
    return "Navigateur";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleString("fr-FR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  };

  return (
    <div className="p-4 sm:p-6 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-bold text-white flex items-center gap-2">
          <Shield className="w-5 h-5 text-amber-500" />
          Sessions actives
        </h2>
        {sessions.length > 1 && (
          <Button
            onClick={revokeAllSessions}
            variant="ghost"
            size="sm"
            className="text-red-400 hover:text-red-300 hover:bg-red-500/10 text-xs"
          >
            <Trash2 className="w-3.5 h-3.5 mr-1" />
            Révoquer les autres
          </Button>
        )}
      </div>

      {isLoadingSessions ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-6 h-6 text-zinc-500 animate-spin" />
        </div>
      ) : sessions.length === 0 ? (
        <div className="text-center py-12 text-zinc-500 text-sm">
          Aucune session active
        </div>
      ) : (
        <div className="space-y-3">
          {sessions.map((session) => {
            const DeviceIcon = getDeviceIcon(session.user_agent);
            return (
              <div
                key={session.session_id}
                className={`bg-zinc-900/30 backdrop-blur-sm border rounded-xl p-4 transition-colors duration-200 ${
                  session.is_current ? "border-amber-500/30 shadow-[0_0_12px_rgba(245,158,11,0.04)]" : "border-zinc-800/50 hover:border-zinc-700/50"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3 min-w-0">
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                      session.is_current ? "bg-amber-500/20" : "bg-zinc-800"
                    }`}>
                      <DeviceIcon className={`w-5 h-5 ${session.is_current ? "text-amber-400" : "text-zinc-400"}`} />
                    </div>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-sm text-white font-medium">
                          {getBrowserName(session.user_agent)}
                        </span>
                        {session.is_current && (
                          <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/30 text-[10px] px-1.5">
                            Session actuelle
                          </Badge>
                        )}
                      </div>
                      <p className="text-xs text-zinc-500 mt-0.5 truncate">
                        IP: {session.ip || "Inconnue"}
                      </p>
                      <p className="text-xs text-zinc-600 mt-0.5">
                        Connecté le {formatDate(session.created_at)}
                      </p>
                    </div>
                  </div>
                  {!session.is_current && (
                    <Button
                      onClick={() => revokeSession(session.session_id)}
                      variant="ghost"
                      size="sm"
                      className="text-red-400 hover:text-red-300 hover:bg-red-500/10 h-8 w-8 p-0 flex-shrink-0"
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
